module.exports = __webpack_public_path__ + "img/rejected.fed20197.svg";